import React, { FC } from 'react';
import useAxios from 'axios-hooks';
import { useSnackbar } from 'notistack';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useSearchParams } from 'react-router-dom';
import { IOrder } from '../../types/strapi';

const Confirmation: FC = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  const { enqueueSnackbar } = useSnackbar();
  const [{ data: order = null, error }] = useAxios<IOrder>(`orders/${orderId}`, {
    useCache: false,
  });

  if (error) {
    enqueueSnackbar(error.message, { variant: 'error' });
  }

  if (order) {
    return (
      <Container>
        <Paper>
          <Typography variant="h3" gutterBottom color="primary">
            Ordine confermato
          </Typography>
          <Typography variant="body1">Il tuo ordine {order.id} è stato registrato.</Typography>
        </Paper>
      </Container>
    );
  } else {
    return null;
  }
};

export default Confirmation;
